import { loginbyUser } from '@/api/singleCard'
import { setToken, removeToken } from '@/utils/auth'
import Cookies from 'js-cookie'
import * as types from '../mutaion-types'

const singleCard = {
    state: {
    token: '',
  },
  mutations: {
    [types.SET_TOKEN]: (state, token) => {
      state.token = token
    },
  },
  actions: {
    getSingleCardData({ commit }, { syncTimeStart,syncTimeEnd,cardNo,vehicleNo,page,pageSize }) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await loginbyUser(syncTimeStart,syncTimeEnd,cardNo,vehicleNo,page,pageSize)
          // if (response.code == 200) {
          //   commit(types.SET_TOKEN, response.data.username)
          //   setToken(response.data.username)
          //   Cookies.set('user', username)
          // }
          resolve(response)
        } catch (error) {
          reject(error)
        }
      })
    }
  }
}

export default singleCard
